<template>
  <div>
    <youtubePop :visible="isYoutubePop" :youtube="youtubeItem" @close="layerClose"></youtubePop>
    <div class="wrap recommend-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>코치님이 추천한 영상</h3>
      </div>
      <div class="body-wrap">
        <ul>
          <li v-for="(item, index) in youtube" :key="index" @click="showYoutube(item)">
            <h4>
              {{ item.contentCoarch.username }} 코치
              <span>{{ $date(item.contentCreatedDatetime).format("YYYY-MM-DD") }}</span>
            </h4>
            <div class="list-wrap">
              <h5>
                <img :src="item.thum" alt="썸네일" />
              </h5>
              <p>
                {{ item.contentReasonsRecommendation }}
                <span>{{ $date(item.contentCreatedDatetime).format("YYYY-MM-DD") }}</span>
              </p>
            </div>
          </li>
          <li v-for="(item, index) in hqYoutube" :key="index" @click="showYoutube(item)">
            <h4>
              HQ 추천
              <span>{{ $date(item.contentCreatedDatetime).format("YYYY-MM-DD") }}</span>
            </h4>
            <div class="list-wrap">
              <h5>
                <img :src="item.thum" alt="썸네일" />
              </h5>
              <p style="font-size: 12px">
                <span style="color: #101010; font-weight: 700; padding-bottom: 1rem; font-size: 13px !important; padding-top: 0">
                  {{ item.contentTitle }}
                </span>
                {{ item.contentReasonsRecommendation }}
                <span>{{ $date(item.contentCreatedDatetime).format("YYYY-MM-DD") }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import youtubePop from "@/components/pop/youtube_pop.vue";
export default {
  name: "coach_recomment_video",
  data: () => ({
    youtube: [],
    hqYoutube: [],
    isYoutubePop: false,
    youtubeItem: {},
  }),
  components: {
    incBack,
    youtubePop,
  },
  mounted() {
    this.getYoutubeList();
    this.getHqYoutubeList();
  },
  methods: {
    layerClose() {
      this.isYoutubePop = false;
    },
    showYoutube(youtube) {
      this.youtubeItem = youtube;
      this.isYoutubePop = true;
    },
    getHqYoutubeList() {
      this.axios
        .get("/content/recommend/hq?page=1")
        .then((res) => {
          if (res.data.success) {
            this.hqYoutube = res.data.data;
            console.log("/content/recommend/hq?page=1 API 호출 이후 getThum() 함수 실행");
            for (let item of this.hqYoutube) {
              item.thum = this.getThum(item.contentVideoUrl);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getYoutubeList() {
      this.axios
        .get(`/content/recommend/coach/${this.$store.state.userInfo.userIdx}?page=1`)
        .then((res) => {
          if (res.data.success) {
            this.youtube = res.data.data;
            // this.getThum();
            console.log(
              "/content/recommend/coach/${this.$store.state.userInfo.userIdx}?page=1 API 호출 이후 getThum() 함수 실행"
            );
            for (let item of this.youtube) {
              item.thum = this.getThum(item.contentVideoUrl);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getThum(url) {
      let replaceUrl = url;
      let finUrl = "";
      replaceUrl = replaceUrl.replace("https://m.youtube.com/watch?v=", "");
      replaceUrl = replaceUrl.replace("https://youtu.be/", "");
      replaceUrl = replaceUrl.replace("https://www.youtube.com/embed/", "");
      replaceUrl = replaceUrl.replace("https://www.youtube.com/watch?v=", "");
      finUrl = replaceUrl.split("&")[0];
      let yottube_thum = "https://img.youtube.com/vi/" + finUrl + "/hqdefault.jpg";
      return yottube_thum;
    },
  },
};
</script>
